export default function Modal(theme) {
  return {
    MuiModal: {
      styleOverrides: {},
      defaultProps: {
        disableScrollLock: true,
      },
    },
  };
}
